import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=7366028a&scoped=true"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js"

import "./UpdatePasswordForm.vue?vue&type=style&index=0&id=7366028a&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7366028a"]])

export default __exports__